import type { CSSProperties } from 'react';

/** Crop/zoom tuning so the portrait sits lower with space above the headphones. */
export const WES_AVATAR_IMAGE_STYLE: CSSProperties = {
  objectPosition: '50% 30%',
  transform: 'scale(0.86)',
  transformOrigin: '50% 40%',
};
